module.exports = __webpack_public_path__ + "static/img/shoujishuma.b1c0dff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/type/daohang/shoujishuma.png
// module id = ns0d
// module chunks = 12